import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ask-approval',
  templateUrl: './ask-approval.component.html',
  styleUrls: ['./ask-approval.component.scss'],
})
export class AskApprovalComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<AskApprovalComponent>) {}

  ngOnInit() {}

  close(option) {
    this.dialogRef.close(option);
  }
}
